<template>
  <v-row no-gutters>
    <ShowcaseDashboard></ShowcaseDashboard>
    <ShowcaseList></ShowcaseList>
  </v-row>
</template>

<script>
import ShowcaseList from './ShowcaseList'
import ShowcaseDashboard from './ShowcaseDashboard'
export default {
  name: 'ShowcaseAutomation',
  components: { ShowcaseList, ShowcaseDashboard },
  data: () => ({})
}
</script>

<style scoped></style>
